import { render, staticRenderFns } from "./MasqueradeAsUser.vue?vue&type=template&id=2892c6a2&scoped=true&"
import script from "./MasqueradeAsUser.vue?vue&type=script&lang=js&"
export * from "./MasqueradeAsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892c6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2892c6a2')) {
      api.createRecord('2892c6a2', component.options)
    } else {
      api.reload('2892c6a2', component.options)
    }
    module.hot.accept("./MasqueradeAsUser.vue?vue&type=template&id=2892c6a2&scoped=true&", function () {
      api.rerender('2892c6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/components/MasqueradeAsUser.vue"
export default component.exports